import CartSinglePageWinback from './CartSinglePageWinback'

export default CartSinglePageWinback
// eslint-disable-next-line import/export
export * from './CartSinglePageWinback'
